const styles = theme => ({
  content: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    height: '100%',
    marginLeft: 24,
    marginRight: 24,
    marginBottom: 24,
    paddingLeft: 0,
    paddingTop: 16,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 64px)',
      marginLeft: 24,
      marginRight: 24,
      paddingTop: 16
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: 16,
      height: 'calc(100% - 64px)',
      marginLeft: 24,
      marginRight: 24,
      width: 'calc(100%)'
    }
  },
  card: {
    minWidth: 100,
    textAlign: 'center',
    alignItems: 'center',
    maxWidth: 'calc(100% - 60px)',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 'calc( (100% - 400px) * 0.5)',
      maxWidth: 400
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 'calc( (100% - 400px) * 0.5)',
      maxWidth: 400
    }
  },
  space: {
    marginBottom: 24
  },
  button: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    textColor: 'black',
    background: 'rgba(100,151,255,1)'
  },
  buttonNoFilter: {
    alignItems: 'center',
    textAlign: 'center',
    marginLeft: 'calc(-18%)',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 0
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 0
    }
  },
  buttonYellow: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    background: 'rgba(252,242,57,1.0)',
    '&:hover': {
      background: 'rgba(252,242,57,0.8)'
    }
  },
  buttonLightGreen: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    background: 'rgba(185,201,130,1)',
    '&:hover': {
      background: 'rgba(185,201,130,0.8)'
    }
  },
  buttonDating: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    background: 'rgba(88,157,42,1)',
    '&:hover': {
      background: 'rgba(88,157,42,0.8)'
    }
  },
  buttonPursuing: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    background: 'rgba(188,231,62,1)',
    '&:hover': {
      background: 'rgba(188,231,62,0.8)'
    }
  },
  buttonWaiting: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    background: 'rgba(234,166,165,1)',
    '&:hover': {
      background: 'rgba(234,166,165,0.8)'
    }
  },
  buttonGaveUp: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    background: 'rgba(174,1,0,1)',
    '&:hover': {
      background: 'rgba(174,1,0,0.8)'
    }
  },
  buttonBlack: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    background: 'black'
  },
  buttonRed: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    background: 'red'
  },
  buttonPink: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    background: 'pink'
  },
  buttonOtherGreen: {
    marginTop: 12,
    marginBottom: 12,
    minWidth: 230,
    background: 'rgba(192,231,81,1)',
    '&:hover': {
      background: 'rgba(192,231,81,0.8)'
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/scenes/PriorityColor/styles.js